import  { getGraphByTextbookId } from '@/api/courseApi/knowledge.js'
export default {
  namespaced: true,
  state: {
    knowledgeGraph: {}
  },
  getters: {
    knowledgeGraph(state) {
      return state.knowledgeGraph
    }
  },
  mutations: {
    setKnowledgeGraph(state, graph) {
      state.knowledgeGraph = graph
    }
  },
  actions: {
    // setKnowledgeGraph({ commit }) {
    //   return new Promise((resolve, reject) => {
    //     getGraphByTextbookId({
    //       textbookId: this.$route.params.graphId
    //     }).then(({result}) => {
    //       console.log(result)
    //     }).catch(() => {
    //       reject()
    //     })
    //   })
    // }
  }
}
